import { collection, doc, getDocs, Timestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../config';
import { masterStatus } from '../../../../constants/enum';

// 辞書を論理削除する。マスタ照合と同じ思想で、物理削除はせず status=99 にする。
// 本体と配下の dictionary_mappings を status=99 にし、変換履歴（conversion_histories）は残す
// （運営が後から使われ方を確認できるようにするため）。
export const deleteDictionary = async (dictionaryId: string): Promise<void> => {
  const now = Timestamp.now();

  // 配下の dictionary_mappings を論理削除
  const mappingsRef = collection(db, 'dictionaries', dictionaryId, 'dictionary_mappings');
  const mappingsSnap = await getDocs(mappingsRef);
  await Promise.all(
    mappingsSnap.docs.map(d => updateDoc(d.ref, { status: masterStatus.deleted, updated_at: now })),
  );

  // 本体を論理削除
  await updateDoc(doc(db, 'dictionaries', dictionaryId), {
    status: masterStatus.deleted,
    updated_at: now,
  });
};
